// extracted by mini-css-extract-plugin
module.exports = {"rowGroupHeader":"GroupHeaderTemplate_rowGroupHeader__3Hny5"};